import React from "react";
import { FieldGroup, TextField } from "@td/ui";
import { fieldTypes } from "../constants";
import { translate } from "@td/shared_utils";

const PracticeNameField = React.memo((props) => (
  <FieldGroup>
    <TextField
      {...props}
      name={fieldTypes.PRACTICE_NAME}
      label={`${translate(null, "practice_team.editing.fields.practice_name", "label")}*`}
      placeholder={translate(null, "practice_team.editing.fields.practice_name", "placeholder")}
    />
  </FieldGroup>
));

export default PracticeNameField;
